module.exports = __webpack_public_path__ + "img/analyzing-photo-desktop-ru.50b4a1c3.jpg";